import React, { useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const succeeded = searchParams.get("state") === "success";

  useEffect(() => {
    if (succeeded) clearCart();
  }, [succeeded, clearCart]);

  return (
    <main className="successDiv">
      <div className="success-container">
        <div className={`modal-content ${succeeded ? "payment-success" : "payment-cancel"}`}>
          <div className="payment-result-icon">
            <FontAwesomeIcon icon={succeeded ? faCheck : faXmark} />
          </div>
          <h1>{succeeded ? "Payment successful" : "Payment cancelled"}</h1>
          <p>
            {succeeded
              ? "Thank you. Your order has been received."
              : "Your payment was not completed. You can return to your cart and try again."}
          </p>
          <Link className="payment-result-link" to={succeeded ? "/shop" : "/cartpage"}>
            {succeeded ? "Continue shopping" : "Return to cart"}
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaymentResult;
